export enum GrowingProcessTypeEnum {
  POND = 'pond',
}
